<template>
    <Container class="container-sm-none">
        <Card class="card-shadow mt-15 mt-md-0">
            <div class="width-lg">
                <div class="pl-10 pl-md-0 pr-10 pr-md-0">
                    <IconSadPerson />
                    <p class="heading-2 heading-md-1 weight-medium mt-20">
                        Sorry, the service is currently unavailable.
                    </p>
                </div>
            </div>
        </Card>
    </Container>
</template>

<script>
import IconSadPerson from '@/components/Icons/IconSadPerson.vue';
import Container from '@/components/Container/Container.vue';
import Card from '@/components/Card/Card.vue';

export default {
  name: 'NotAvailablePage',
  components: {
    IconSadPerson,
    Container,
    Card,
  },
  created() {
    this.model.step = 21;
    if (this.model.lastStep < 21) this.model.lastStep = 21;
  },
};
</script>
